import React from 'react';
import { Building2, Shield, Users, Truck } from 'lucide-react';

const About = () => {
  const stats = [
    { icon: <Building2 className="h-8 w-8 text-teal-600" />, label: 'Years of Excellence', value: '15+' },
    { icon: <Users className="h-8 w-8 text-teal-600" />, label: 'Happy Clients', value: '500+' },
    { icon: <Truck className="h-8 w-8 text-teal-600" />, label: 'Delivery Partners', value: '50+' },
    { icon: <Shield className="h-8 w-8 text-teal-600" />, label: 'Quality Products', value: '1000+' },
  ];

  return (
    <div className="py-16 bg-gray-50">
      <div className="container-custom">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">About Us</h1>
          <div className="w-24 h-1 bg-teal-600 mx-auto rounded-full"></div>
        </div>

        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <img 
              src="https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" 
              alt="Pharmacy Warehouse" 
              className="rounded-xl shadow-lg w-full h-[400px] object-cover"
            />
          </div>
          <div>
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Welcome to K.K. Pharmaceuticals</h2>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Established with a vision to provide quality healthcare products to the people of Gondia and surrounding regions, K.K. Pharmaceuticals has grown to become a trusted name in pharmaceutical distribution.
            </p>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Located at Kk Complex, At-Thana, Amgaon, our state-of-the-art facility ensures that all pharmaceutical products are stored under optimal conditions, maintaining their efficacy and safety standards.
            </p>
            <p className="text-gray-600 mb-6 leading-relaxed">
              We pride ourselves on our strong network of suppliers and our commitment to timely deliveries, making us the preferred choice for hospitals, clinics, and retail pharmacies in the region.
            </p>
            <div className="flex space-x-4">
              <div className="bg-white p-4 rounded-lg shadow-md flex-1">
                <p className="font-bold text-teal-600 text-2xl">9AM-5PM</p>
                <p className="text-gray-500 text-sm">Business Hours</p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow-md flex-1">
                <p className="font-bold text-teal-600 text-2xl">Mon-Sat</p>
                <p className="text-gray-500 text-sm">Working Days</p>
              </div>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-8">
          {stats.map((stat, index) => (
            <div key={index} className="bg-white p-6 rounded-xl shadow-md text-center transition hover:shadow-lg">
              <div className="flex justify-center mb-3">{stat.icon}</div>
              <div className="text-2xl font-bold text-gray-800">{stat.value}</div>
              <div className="text-gray-500 text-sm">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Mission & Vision */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-16">
          <div className="bg-white p-8 rounded-xl shadow-md">
            <h3 className="text-2xl font-bold text-gray-800 mb-4">Our Mission</h3>
            <p className="text-gray-600">
              To ensure the availability of high-quality pharmaceutical products at competitive prices, while maintaining the highest standards of storage and distribution.
            </p>
          </div>
          <div className="bg-white p-8 rounded-xl shadow-md">
            <h3 className="text-2xl font-bold text-gray-800 mb-4">Our Vision</h3>
            <p className="text-gray-600">
              To be the leading pharmaceutical dealership in Maharashtra, recognized for integrity, reliability, and commitment to community health.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;